import React, { useEffect, useState } from 'react'
import { createCancellation } from "../../../Context/api";
import { policyAddValidation } from '../../../Context/validation';
import axios from "axios";
import { commonMessage, statusCodes } from "../../../Constants/generalConfig";
import Spinner from '../../Spinner/spinner';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';


const AddPolicy = () => {
    const [spinner, setSpinner] = useState(false)
    const navigate = useNavigate()

    const policyAdd = useFormik({
        initialValues: {
            refundType: '',
            validity: '',
            days: '',
            cancellationCharge:''
        },
        validationSchema: policyAddValidation,
        onSubmit: (values) => {
            const data = {
                refundType: values.refundType,
                validity: values.validity,
                days: values.days,
                cancellationCharge:values.cancellationCharge
            } 
            axios.post(createCancellation(), data).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    policyAdd.resetForm()
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                    }, 1000);
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                    setSpinner(false)
                })
        }
    })
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Add Policy
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={policyAdd.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Refund Type *</label>
                            <select className='form-select' name='refundType'
                                onChange={policyAdd.handleChange}
                                value={policyAdd.values.refundType}>
                                  <option value="" hidden>Select</option>
                                  <option value="FULL">Full</option>
                                  <option value="PARTIAL">Partial</option>
                                </select>
                            {policyAdd.touched.refundType && policyAdd.errors.refundType ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyAdd.errors.refundType}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Validity *</label>
                            <select className='form-select' name='validity'
                                onChange={policyAdd.handleChange}
                                value={policyAdd.values.validity}>
                                  <option value="" hidden>Select</option>
                                  <option value="MONTHLY">Monthly</option>
                                  <option value="YEARLY">Yearly</option>
                                </select>
                            {policyAdd.touched.validity && policyAdd.errors.validity ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyAdd.errors.validity}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Days *</label>
                            <input type="number" className="form-control"
                                id="recipient-name"
                                maxLength={10}
                                name='days'
                                onChange={policyAdd.handleChange}
                                value={policyAdd.values.days}
                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}

                            />
                            {policyAdd.touched.days && policyAdd.errors.days ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyAdd.errors.days}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Charges (%)*</label>
                            <input type="number" className="form-control"
                                id="recipient-name"
                                maxLength={10}
                                name='cancellationCharge'
                                onChange={policyAdd.handleChange}
                                value={policyAdd.values.cancellationCharge}
                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}

                            />
                            {policyAdd.touched.cancellationCharge && policyAdd.errors.cancellationCharge ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyAdd.errors.cancellationCharge}
                                </div>
                            ) : null}
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>


               
            </section>
        </>
    )
}

export default AddPolicy